import { z } from "zod";

/**
 * Validated frontend environment. Fails fast at module load if a
 * required variable is missing, instead of failing mysteriously at
 * request time.
 */
const envSchema = z.object({
  VITE_API_BASE_URL: z.string().min(1).default("/api"),
});

export const env = envSchema.parse(import.meta.env);
